import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';

export type commonStateType = {
  isFromPhoto?: boolean;
};

const initialState: commonStateType = {
  isFromPhoto: false
};

export const commonStateSlice = createSlice({
  name: 'commonStateSlice',
  initialState,
  reducers: {
    setCommonState: (state, action) => {
      const { isFromPhoto } = action.payload;
      state.isFromPhoto = isFromPhoto;
      return state;
    },
    resetCommonState: () => {
      return initialState;
    }
  }
});

export const { setCommonState } = commonStateSlice.actions;

export const getCommonState = (state: RootState) => state.commonStateSlice;
